export const Categories = {
  Twitch: "twitch",
  Time: "time",
  Poll: "poll",
  Twitter: "twitter",
  Donation: "donation",
  Custom: "custom"
};



// WEBPACK FOOTER //
// ./src/spreadsheet/constants.js